export default {"src":"/_next/static/media/logo.7f5b370a.svg","height":25,"width":186,"blurWidth":0,"blurHeight":0};